export default "__VITE_ASSET__DVVHgFPW__"